/**
 * CapacityStrip.tsx
 * Per-machine utilization mini-bar shown under the machine name when the
 * capacity heatmap is toggled on (Machine Schedule UX — M6).
 */

import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import type { CapacityBand } from '../../utils/scheduleCapacity';

interface CapacityStripProps {
  /** Utilization fraction (0..n). */
  pct: number;
  band: CapacityBand;
}

export const CapacityStrip: React.FC<CapacityStripProps> = ({ pct, band }) => {
  const theme = useTheme();
  const color =
    band === 'high'
      ? theme.schedule.heatmapHigh
      : band === 'mid'
        ? theme.schedule.heatmapMid
        : theme.schedule.heatmapLow;
  const display = Math.round(pct * 100);
  return (
    <Tooltip title={`${display}% booked this window`} placement="right">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.25 }}>
        <Box
          sx={{
            flex: 1,
            height: 4,
            borderRadius: 2,
            backgroundColor: alpha(color, 0.22),
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{ width: `${Math.min(100, display)}%`, height: '100%', backgroundColor: color }}
          />
        </Box>
        <Typography sx={{ fontSize: '0.55rem', fontWeight: 700, color, lineHeight: 1 }}>
          {display}%
        </Typography>
      </Box>
    </Tooltip>
  );
};
